import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionService } from '../../services/user-role-permission.service';
import { AuthDavesaV2Service } from '../auth-davesa-v2.service';

export const PermissionGuard: CanActivateFn | CanActivateChildFn = async (route, state) => {
  const permissionService = inject(PermissionService);
  const authService = inject(AuthDavesaV2Service);
  const router = inject(Router);

  // Ensure user role is loaded/refreshed
  await authService.ensureUserRoleLoaded();

  const currentRoute = state.url;

  // Check if user has permission for this route
  const hasPermission = permissionService.hasPermissionForRoute(currentRoute);

  if (!hasPermission) {
    // Redirect to no permission page
    return router.parseUrl('/no-permission');
  }

  return true;
}; 